import { cn } from "@/lib/utils";
import { dDayLabel } from "@buildpy/core/modules/project/view";

interface Props {
  // dDayOf 의 결과 — null 이면 아무것도 그리지 않는다.
  days: number | null;
  // 착공 전일 때만 지난 날을 경고색으로 칠한다.
  warnPast: boolean;
  className?: string;
}

const DDayBadge = ({ days, warnPast, className }: Props) => {
  if (days === null) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-semibold tabular-nums",
        warnPast && days <= 0 ? "bg-destructive/10 text-destructive" : "bg-muted text-muted-foreground",
        className
      )}>
      {dDayLabel(days)}
    </span>
  );
};

export default DDayBadge;
